import { useInfiniteQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { historyService } from '../../services/historyService';

export const useGetRoundBrandsById = fundraisingId => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.history.brands_batch_by_id, fundraisingId],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await historyService.brandsBatchById(fundraisingId, {
        page: pageParam,
        limit: 100,
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      }
      throw new Error('Fetch failed');
    },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage) return;
      const currentPage = allPages.length;
      const hasNextPage = currentPage < lastPage.total_pages;
      return hasNextPage ? currentPage + 1 : undefined;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
